export default __webpack_public_path__ + "static/media/bengals_black.76fedac2.png";